import {
    Alert,
    Button,
    Col,
    Container,
    Icon,
    Modal,
    Row,
    Table,
    TextArea
} from "design-react-kit";
import React, {useEffect, useState} from "react";
import {properties} from "../../../config/properties";
import { useLocation,useNavigate } from "react-router-dom";
import Spinner from "../../layout/Spinner";
import SpinnerCustom from "../../layout/Spinner";

// Stili unificati, ispirati all'esempio fornito
const styles = {
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '70vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    formContainer: {
        backgroundColor: '#ffffff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.07)',
        border: '1px solid #dee2e6'
    },
    formTitle: {
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#333',
        marginBottom: '1.5rem',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
    },
    highlightedRow: {
        backgroundColor: 'rgba(0, 102, 204, 0.1)',
        transition: 'background-color 0.3s ease-in-out',
    },
    infoBox: {
        padding: '2rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    }
};

// --- Componente per il Form di Modifica ---
const FormModificaAreaCompetenza = ({area, onSave, onCancel,user}) => {
    const [descrizione, setDescrizione] = useState('');
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (area) {
            setDescrizione(area.descrAreaCompetenza);
        }
    }, [area]);

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setError(null);

        try {


            const response = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/update/areaCompetenza`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({descrizione: descrizione, id: area.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente})
            });

            if(response.status === 401){

                const datasResponse = await response.json();

                setError("Errore di comunicazione con il server.");

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const result = await response.json();
            if (result.esito === "OK") {
                onSave(); // Notifica il successo al componente genitore
            } else {
                setError(result.messaggio || "Operazione fallita");
            }
        } catch (err) {
            setError("Errore di rete o server non raggiungibile.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!area) return null;

    return (
        <div style={styles.formContainer}>
            <h3 style={styles.formTitle}>Modifica Area</h3>
            {error && <Alert color="danger">{error}</Alert>}
            <form onSubmit={handleConfirm}>
                <TextArea
                    id="descrizione"
                    label="Descrizione"
                    value={descrizione}
                    onChange={(e) => setDescrizione(e.target.value)}
                    rows={4}
                    required
                    maxLength={140}
                />
                <div className="mt-4" style={styles.buttonGroup}>
                    <Button className="btn btn-outline-secondary" outline type="button" onClick={onCancel}>
                        Annulla
                    </Button>
                    <Button className="btn btn-outline-primary" type="submit" disabled={isSaving}>
                        {isSaving ? 'Salvataggio...' : 'Salva'}
                    </Button>
                </div>
            </form>
        </div>
    );
};


// --- Componente Principale ---
const GestioneAreeCompetenza = ({user}) => {

    const navigate = useNavigate();

    const [aree, setAree] = useState([]);
    const [alert, setAlert] = useState({visible: false, type: '', message: ''});
    const [areaInModifica, setAreaInModifica] = useState(null);
    const [areaToDelete, setAreaToDelete] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [loadingUser, setLoadingUser] = useState(true);
    const location = useLocation();

    // Funzione per caricare i dati
    const fetchAree = async () => {

        try{
            const data = await getAreeList();
            setAree(data?.areeCompetenza ?? []);
        }catch(e){
            setAree([]);
        }

    };

    useEffect(() => {
        fetchAree();
    }, []);

    // Gestisce i messaggi di stato (es. dopo una creazione/modifica da un'altra pagina)
    useEffect(() => {
        if (location.state?.esito) {
            setAlert({ visible: false, type: '', message: '' });
            window.scrollTo({top: 0, behavior: 'smooth'});
            const message = location.state.esito.messaggio;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({visible: true, type, message});
        }
        navigate(location.pathname, { replace: true });
    }, [location.state]);

    // --- Gestori di Azioni ---
    const handleEditClick = (area) => {
        setAreaInModifica(area);
        setAlert({visible: false}); // Nasconde alert precedenti
    };

    const handleCancelEdit = () => {
        setAreaInModifica(null);
    };

    const handleSaveSuccess = () => {
        setAreaInModifica(null);
        setAlert({visible: true, type: 'success', message: 'Area di competenza aggiornata con successo!'});
        window.scrollTo({top: 0, behavior: 'smooth'});
        fetchAree(); // Ricarica la lista per mostrare i dati aggiornati
    };

    const openDeleteConfirm = (area) => {
        setAreaToDelete(area);
        setShowConfirmModal(true);
    };

    const closeDeleteConfirm = () => {
        setAreaToDelete(null);
        setShowConfirmModal(false);
    };

    const confirmDelete = async () => {
        setAlert({ visible: false, type: '', message: '' });
        if (!areaToDelete) return;

        try {


            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/delete/areaCompetenza`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({id: areaToDelete.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const json = await res.json();

            if (json.esito === "OK") {
                setAlert({visible: true, type: 'success', message: 'Area di competenza eliminata correttamente.'});
                window.scrollTo({top: 0, behavior: 'smooth'});
                fetchAree();

            } else {
                setAlert({
                    visible: true,
                    type: 'danger',
                    message: json.messaggio || 'Errore: non è possibile eliminare un\'area assegnata.'
                });
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        } catch (e) {
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            window.scrollTo({top: 0, behavior: 'smooth'});
        } finally {
            closeDeleteConfirm();
        }
    };

    // Funzione helper per recuperare i dati (resa più robusta)
    async function getAreeList() {


        try {

            setLoadingUser(true);

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/areeCompetenza`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),
            });


            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error(`Errore HTTP: ${res.status}`);
            return await res.json();
        } catch (e) {
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            return []; // Ritorna un array vuoto in caso di errore per evitare crash
        } finally {
            setLoadingUser(false);
        }
    }

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <SpinnerCustom active/>


            </Container>
        );


    }

    return (
        <div className="bg-white py-5 py-lg-6">
            <Container>
                <h2 className="mb-5">Gestione Aree di Competenza</h2>

                {alert.visible && (
                    <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({...alert, visible: false})}>
                        {alert.message}
                    </Alert>
                )}

                <Row>
                    {(
                        <Col md={5} hidden={areaInModifica} className="transition-all duration-300">
                            <Container>

                                <div className="guidance-box lead">
                                    <p className="">
                                        Crea una nuova area competenza per modellare l'esperienza sulla nostra
                                        piattaforma. Inizia con un nome chiaro e rappresentativo, poi cura
                                        l'ordinamento di essi se desiderato.
                                    </p>

                                    <div style={{display:'flex'}}>
                                        <div style={{flex:1, padding:"1.68%"}} align={"right"}>
                                            <Button className="btn btn-outline-primary" outline onClick={() => {
                                                navigate('/private/inserimentoAreaCompetenza')
                                            }}> Inserisci Area</Button>
                                        </div>
                                        <div style={{flex:1, padding:"1.68%"}} align={"left"}>
                                            <Button className="btn btn-outline-secondary" outline onClick={() => {
                                                navigate('/private/ordinamentoAreeCompetenza')
                                            }}>Ordina Aree</Button>
                                        </div>

                                    </div>



                                </div>



                            </Container>
                        </Col>
                    )}

                    {/* Colonna Sinistra: Tabella delle Aree */}
                    <Col md={areaInModifica ? 8 : 7} className="transition-all duration-300">
                            <Table  hover>
                                <thead>
                                <tr>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Descrizione</th>
                                    <th scope="col" className="text-left" style={{...styles.tableHeader, width: '15%'}}>Azioni</th>
                                </tr>
                                </thead>
                            </Table>
                        <div style={styles.tableContainer} className="custom-scrollbar">

                        <Table  className="border-0" >

                                <tbody>
                                {aree.length > 0 ? (
                                    aree.map((area, index) => {
                                        const isHighlighted = areaInModifica && area.id === areaInModifica.id;
                                        return (
                                            <tr key={area.id} style={isHighlighted ? styles.highlightedRow : undefined}>
                                                <td className="text-right" style={styles.tableRowText}>{area.descrAreaCompetenza}</td>
                                                <td className="text-right" style={{...styles.tableRowText, width: '15%'}} >
                                                    <button className={"action-icon"} style={styles.actionButton} onClick={() => handleEditClick(area)} aria-label={`Modifica ${area.descrAreaCompetenza}`}>
                                                        <Icon icon="it-pencil" color="primary"/>
                                                    </button>
                                                    <button className={"action-icon"} style={styles.actionButton} onClick={() => openDeleteConfirm(area)} aria-label={`Elimina ${area.descrAreaCompetenza}`}>
                                                        <Icon icon="it-delete" color="danger"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center" style={styles.tableRowText}>
                                            Nessuna area di competenza trovata.
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                        </div>

                        {aree.length > 0 && (
                            <>
                                <Row className="mt-2">
                                    <Col className="text-end">
                                        <small className="text-muted">
                                            <strong>{aree.length}</strong>  risultati
                                        </small>
                                    </Col>
                                </Row>

                            </>
                        )}

                    </Col>

                    {/* Colonna Destra: Form di Modifica (visibile condizionalmente) */}
                    {areaInModifica && (
                        <Col  md={4} className="transition-all duration-500">
                            <FormModificaAreaCompetenza
                                area={areaInModifica}
                                onSave={handleSaveSuccess}
                                onCancel={handleCancelEdit}
                                user={user}
                            />
                        </Col>
                    )}
                </Row>
                <Spinner active = {!setAree}/>

            </Container>

            {/* Modale di Conferma Eliminazione */}
            <Modal isOpen={showConfirmModal} toggle={closeDeleteConfirm} centered>
                <div className="modal-header">
                    <h5 className="modal-title">Conferma Eliminazione</h5>
                    <button type="button" className="btn-close" aria-label="Close" onClick={closeDeleteConfirm}></button>
                </div>
                <div className="modal-body">
                    Sei sicuro di voler eliminare l'area: <strong>{areaToDelete?.descrAreaCompetenza}</strong>?
                    <br/>
                    L'azione non potrà essere annullata.
                </div>
                <div className="modal-footer">
                    <Button color="secondary" outline onClick={closeDeleteConfirm}>Annulla</Button>
                    <Button color="danger" onClick={confirmDelete}>Conferma ed Elimina</Button>
                </div>
            </Modal>
        </div>
    );
}



export default GestioneAreeCompetenza;